import React from "react";
import getFormattedDate from "./getFormattedDate";
import { DynamicDateProps } from "./types/types";

const DynamicDate: React.FC<DynamicDateProps> = ({
	dateType,
	currentDate,
	numberOfPeriodsAgo,
	showMonthName,
	showLeadingZero,
	showAbbreviatedName,
	showMonthDay,
}) => {
	return (
		<span>
			{getFormattedDate(
				dateType,
				currentDate,
				numberOfPeriodsAgo,
				showMonthName,
				showLeadingZero,
				showAbbreviatedName,
				showMonthDay,
			)}
		</span>
	);
};

export default DynamicDate;
